import dayjs from 'dayjs'
import { DurationUnits } from '@/constants/date/DurationUnits'

export function add23Hours59MinutesToDate(date) {
  return dayjs(date)
    .add(23, DurationUnits.HOUR)
    .add(59, DurationUnits.MINUTE)
    .add(59, DurationUnits.SECOND)
}

/**
 * Determines whether the month component of a date to be presented should
 * proceed the day component for a specified locale.
 *
 * @param locale The locale to check
 * @returns {Boolean}
 */
const isMonthBeforeDay = (locale) => {
  return (
    dayjs().locale(locale.toLowerCase()).localeData().longDateFormat('L') ===
    'MM/DD/YYYY'
  )
}

export { isMonthBeforeDay }
